import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
    /** 'light' fits a white navbar; 'dark' fits the navy/slate ESS sidebar. */
    theme?: 'light' | 'dark';
    className?: string;
}

/**
 * EN/AR switch. Flipping it changes i18next's active language, which in turn
 * (see i18n/index.ts's languageChanged listener) sets <html dir>, so this one
 * control drives both the text translation and the whole page's RTL mirroring.
 */
export default function LanguageToggle({ theme = 'light', className = '' }: LanguageToggleProps) {
    const { i18n } = useTranslation();
    const isArabic = i18n.language?.startsWith('ar');

    const toggle = () => {
        i18n.changeLanguage(isArabic ? 'en' : 'ar');
    };

    const track = theme === 'dark'
        ? 'bg-white/10 border-white/10 text-slate-300'
        : 'bg-gray-100 border-gray-200 text-gray-500';
    const activeChip = theme === 'dark'
        ? 'bg-indigo-500 text-white'
        : 'bg-blue-600 text-white';

    return (
        <button
            type="button"
            onClick={toggle}
            title={isArabic ? 'Switch to English' : 'التبديل إلى العربية'}
            className={`inline-flex items-center rounded-full border p-0.5 text-[11px] font-bold transition-colors ${track} ${className}`}
        >
            <span className={`px-2.5 py-1 rounded-full transition-all ${!isArabic ? activeChip : ''}`}>EN</span>
            <span className={`px-2.5 py-1 rounded-full transition-all ${isArabic ? activeChip : ''}`}>عربي</span>
        </button>
    );
}
